import {
    Component
} from '@angular/core';
import {
    TaskBaseMagicComponent,
    magicProviders
} from "@magic-xpa/angular";
import {
    MagicModalInterface
} from "@magic-xpa/angular";
//
import { FormControl, FormGroup } from '@angular/forms'; 
import { variable } from '@angular/compiler/src/output/output_ast';
//
@Component({
    selector: 'mga-Logout',
    providers: [...magicProviders],
    styleUrls: ['./Logout.component.css'],
    templateUrl: './Logout.component.html'
}) export class Logout extends TaskBaseMagicComponent implements MagicModalInterface {
    private static readonly formName: string = "Logout";
    private static readonly showTitleBar: boolean = false;
    private static readonly x: number = 0;
    private static readonly y: number = 0;
    private static readonly width: string = "205px";
    private static readonly height: string = "128px";
    private static readonly isCenteredToWindow: boolean = true;
    private static readonly shouldCloseOnBackgroundClick = false;
    X() {
        return Logout.x;
    }
    Y() {
        return Logout.y;
    }
    Width(): string {
        return Logout.width;
    }
    Height(): string {
        return Logout.height;
    }
    IsCenteredToWindow() {
        return Logout.isCenteredToWindow;
    }
    FormName() {
        return Logout.formName;
    }
    ShowTitleBar() {
        return Logout.showTitleBar;
    }
    ShouldCloseOnBackgroundClick() {
        return Logout.shouldCloseOnBackgroundClick;
    }
	
	//
	// 2020-08-18 (MFCS)
	//
    ngOnInit() {
        super.ngOnInit();
        let group: FormGroup = this.screenFormGroup; 
        (<FormControl>group.controls['vFlag_to_Switch']).registerOnChange(this.OnChange.bind(this));
      }
    OnChange() {
        if(this.mg.getValue('vFlag_to_Switch') !== undefined && this.mg.getValue('vFlag_to_Switch')!==null){
			var fContent = this.mg.getValue('vFlag_to_Switch');
			if( fContent.toLowerCase().lastIndexOf("http", 0) === 0 ) {
				// Começa com HTTP o valor do campo
				window.location.href = fContent;
			}
        }
    }	
}